import { Injectable } from '@angular/core';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Computed, StateRepository } from '@angular-ru/ngxs/decorators';
import { State } from '@ngxs/store';
import { ReachEventCompanyLead, ReachEventCompanyLeadPayload, ReachEventCompanyLeadService } from '@portals/api';

import { finalize, mergeMap, tap } from 'rxjs/operators';

interface StateModel {
	isLoading: boolean;
	data: Array<ReachEventCompanyLead>;
	selected: ReachEventCompanyLead;
}

@StateRepository()
@State<StateModel>({
	name: 'company_leads',
})
@Injectable()
export class ReachEventCompanyLeadsState extends NgxsDataRepository<StateModel> {
	@Computed()
	get isLoading() {
		return this.snapshot.isLoading;
	}

	@Computed()
	get hasData() {
		return !!this.snapshot.data;
	}

	@Computed()
	get data() {
		return this.snapshot.data;
	}

	@Computed()
	get item() {
		return this.snapshot.selected;
	}

	constructor(private reachEventCompanyLeadService: ReachEventCompanyLeadService) {
		super();
	}

	load() {
		this.patchState({ isLoading: true });

		return this.reachEventCompanyLeadService.find({ params: { sort: 'createdAt:desc' } }).pipe(
			tap(({ data }) => {
				this.patchState({ data });
			}),
			finalize(() => {
				this.patchState({ isLoading: false });
			})
		);
	}

	findOne(id: number) {
		return this.reachEventCompanyLeadService.findOne(id);
	}

	create(payload: ReachEventCompanyLeadPayload) {
		this.patchState({ isLoading: true });

		return this.reachEventCompanyLeadService.connect(payload).pipe(mergeMap(() => this.load()));
	}

	update(id: number, formData: FormData) {
		this.patchState({ isLoading: true });

		return this.reachEventCompanyLeadService.update(id, formData).pipe(mergeMap(() => this.load()));
	}
}
